// extracted by mini-css-extract-plugin
export default {"counter-inline":"counter-inline__r_IsA","__style-primary":"__style-primary__nMJ2G","__style-custom":"__style-custom__AoYeC"};